import { useRef } from "@/utils/hooks/reactUseCustomHooks";

const useScrollBlocker = () => {
  const bodyRef = useRef<HTMLDivElement | null>(null);

  const disableBackgroundScroll = () => {
    bodyRef?.current?.ownerDocument?.body?.classList.add("overflow-background");
  };

  const enableBackgroundScroll = () => {
    bodyRef?.current?.ownerDocument?.body?.classList.remove(
      "overflow-background"
    );
  };

  return { bodyRef, disableBackgroundScroll, enableBackgroundScroll };
};
export default useScrollBlocker;
